import { ContentContainer } from "containers";
import styled from "styled-components";

export const ContentWrapper = styled(ContentContainer)`
  margin-top: 20px;
  align-items: flex-start;
`;
